export interface ParcelDimensions {
  weight: number;
  length: number;
  width: number;
  height: number;
}

export interface NonStandardPackaging {
  text: string;
  hint: string;
  enabled: boolean;
}

export interface IDeliveryLimitationsResponse {
  max_weight: number;
  min_weight: number;
  max_vol_weight: number;
  max_side: number;
  max_x: number;
  max_y: number;
  max_z: number;
  limit_warning: string;
  non_standard_packaging: NonStandardPackaging | undefined;
}

export interface RouteNotFoundError {
  message: string;
  title: string;
}

export interface IDeliveryLimitationsRequest {
  shipment_type: string;
  departure_country: string;
  departure_zip: string;
  destination_country: string;
  destination_zip?: string;
}

export interface IDeliveryLimitations {
  maxWeight: number;
  minWeight: number;
  maxVolWeight: number;
  maxSide: number;
  maxX: number;
  maxY: number;
  maxZ: number;
  limitWarning: string;
  nonStandardPackaging: NonStandardPackaging;
}

export const transformDeliveryLimitationsResponse = (
  response?: IDeliveryLimitationsResponse
): IDeliveryLimitations => ({
  maxWeight: response?.max_weight ?? 0,
  minWeight: response?.min_weight ?? 0,
  maxVolWeight: response?.max_vol_weight ?? 0,
  maxSide: response?.max_side ?? 0,
  maxX: response?.max_x ?? 0,
  maxY: response?.max_y ?? 0,
  maxZ: response?.max_z ?? 0,
  limitWarning: response?.limit_warning ?? '',
  nonStandardPackaging: response?.non_standard_packaging ?? {
    text: '',
    hint: '',
    enabled: false,
  },
});
